import { request } from '@luna/api';
import { logger } from '@luna/logger';
import { getFeatureConfig } from '@luna/feature-config';
import { getToken } from '@shared/auth';

import { isReplayingAlexProxySession } from './ProxyCardService';

interface AlexProxySessionDetails {
    id: string;
}

interface AlexProxySessionList {
    content: AlexProxySessionDetails[];
}

function buildAlexProxySessionDetailsUrl(): string {
    const { alexProxyUrl } = getFeatureConfig(({ devTools }) => devTools);
    const url = new URL(alexProxyUrl);
    url.pathname = 'api/proxy/session';
    url.searchParams.set('page', '0');
    url.searchParams.set('pageSize', '1');
    url.searchParams.set(
        'country',
        getFeatureConfig((config) => config.base.country),
    );
    url.searchParams.set('accessToken', getToken());
    url.searchParams.set('fetchSyntheticSessions', isReplayingAlexProxySession().toString());
    return url.toString();
}

export async function loadAlexProxySessionDetailsLink(): Promise<string> {
    try {
        const response = await request<AlexProxySessionList>(buildAlexProxySessionDetailsUrl(), {
            skipAuthHeader: true,
        });

        const sessionId = response.content?.[0]?.id;

        if (!sessionId) {
            return '';
        }

        const { alexProxyUrl } = getFeatureConfig(({ devTools }) => devTools);
        return `${alexProxyUrl}/#/sessions/${sessionId}`;
    } catch (e) {
        logger.error('Loading session details link failed', e);
        return '';
    }
}
